import axios from 'axios';

const apiCall = axios.create({
  baseURL: window.FlowWebsiteGlobalConfig.basePaths.flowController,
})

// See also ApiCallInterceptor.vue for debug utilities

export default apiCall;
